import {AuthStore} from "@auth/domain/auth.config"


export const isAuthenticated = (auth: AuthStore) => auth.status === 'LOGGED_IN'

export type ConfigurationStatus = "INITIALIZED" | "NOT_CONFIGURED" | "CONFIGURED"
export type FeatureTag = ""
export type Platform = "ANDROID" | "WINDOWS"


export interface FeatureRef {
    id: string,
    tag: FeatureTag,
    description: string,
    title: string,
    count: number,
    isInherent?: boolean
    supportedPlatforms: Platform[]
}

export interface ClientConfigurationRef {
    clientId: string;
    status: ConfigurationStatus;
    features: FeatureRef[];
}